import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPreviousIcon from './svgs/PreviousIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var previousIcon = (props => useIcon(SvgPreviousIcon, SvgPreviousIcon, props));

export { previousIcon as default };
